define('glu/grid/filter/manageFiltersLink',['require','../../itemView','hbs!./manageFiltersLink.hbs','../../dialog','../../util','./advancedSearch'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tmpl = require('hbs!./manageFiltersLink.hbs'),
        dialog = require('../../dialog'),
        util = require('../../util'),
        AdvancedSearch = require('./advancedSearch');

    return ItemView.extend({
        template: tmpl,
        tagName: 'ul',
        className: 'item-list grid-manage-filters-link',

        events: {
            'click': 'showAdvancedSearch'
        },

        initialize: function() {
            this.grid = this.options.grid;

            this.advancedFilterView = new AdvancedSearch({
                collection: this.collection,
                filterViewClass: this.options.filterViewClass,
                columns: this.options.columns,
                grid: this.grid,
                filterProc: this.options.filterProc
            });
            this.listenTo(this.advancedFilterView, 'submit', this.handleAdvancedFilterSubmit);
        },

        showAdvancedSearch: function(e) {
            e.preventDefault();
            util.defer(function() {
                if (this.isClosed) {
                    return;
                }
                // need to close opened flexDropdown.
                this.appBus.trigger('open.dropdown');

                dialog.open(this.advancedFilterView);
                this.grid.trigger('filter:advanced', this.advancedFilterView);
            }.bind(this));

        },

        onClose: function() {
            //This is made and sometimes shown in a dialog, but no one ever closes the thing!
            if (this.advancedFilterView) {
                this.advancedFilterView.close();
            }
        },

        handleAdvancedFilterSubmit: function(evt) {
            this.grid.trigger('filter:advanced:submit', evt);
        }
    });
});

